import React from 'react';
import { useIntl } from 'react-intl';
import { Skeleton } from '@material-ui/lab';
import { Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(1)
  },
  rowSkeleton: {
    display: 'flex',
    paddingBottom: theme.spacing(2),
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  resourceSkeleton: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1,
    gap: theme.spacing(2)
  },
  resourceColumn: {
    flex: 1,
    minWidth: theme.spacing(20)
  },
  smartMatchColumn: {
    minWidth: theme.spacing(12)
  },
  availabilityColumn: {
    minWidth: theme.spacing(12)
  },
  buttonSkeleton: {
    marginLeft: theme.spacing(2),
    minWidth: theme.spacing(10.5)
  },
  alternativesText: {
    margin: theme.spacing(1, 0)
  }
}));

export const ResourceMatchListLoading = () => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  return (
    <>
      <div className={classes.root}>
        <Paper key={0} className={classes.rowSkeleton} square elevation={0}>
          <div className={classes.resourceSkeleton}>
            <Skeleton className={classes.resourceColumn} height={46} />
            <Skeleton className={classes.smartMatchColumn} height={46} />
            <Skeleton className={classes.availabilityColumn} height={46} />
            <Skeleton
              className={classes.buttonSkeleton}
              height={46}
              width={90}
            />
          </div>
        </Paper>
        <Typography className={classes.alternativesText} variant="subtitle1">
          {formatMessage({
            id: 'resourceMatchPopover.delaAIsTopAlternatives'
          })}
        </Typography>
      </div>
      {Array.from(Array(3).keys()).map(i => (
        <Paper key={i + 1} className={classes.rowSkeleton} square elevation={0}>
          <div className={classes.resourceSkeleton}>
            <Skeleton className={classes.resourceColumn} height={46} />
            <Skeleton className={classes.smartMatchColumn} height={46} />
            <Skeleton className={classes.availabilityColumn} height={46} />
            <Skeleton
              className={classes.buttonSkeleton}
              height={46}
              width={90}
            />
          </div>
        </Paper>
      ))}
    </>
  );
};

export default ResourceMatchListLoading;
